export const joinProcessReasonConstants = {
  key: '가입 이유',
  values: ['트랙터 구매', '트랙터 판매', '농업 뉴스 및 정보', '지원금 정보', '농기계 정보', '커뮤니티', '기타'],
  labels: [],
};
